"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Possible error messages thrown by an AssetBuyer instance or associated static methods.
 */
var AssetBuyerError;
(function (AssetBuyerError) {
    AssetBuyerError["NoEtherTokenContractFound"] = "NO_ETHER_TOKEN_CONTRACT_FOUND";
    AssetBuyerError["NoZrxTokenContractFound"] = "NO_ZRX_TOKEN_CONTRACT_FOUND";
    AssetBuyerError["StandardRelayerApiError"] = "STANDARD_RELAYER_API_ERROR";
    AssetBuyerError["InsufficientAssetLiquidity"] = "INSUFFICIENT_ASSET_LIQUIDITY";
    AssetBuyerError["InsufficientZrxLiquidity"] = "INSUFFICIENT_ZRX_LIQUIDITY";
    AssetBuyerError["NoAddressAvailable"] = "NO_ADDRESS_AVAILABLE";
    AssetBuyerError["InvalidOrderProviderResponse"] = "INVALID_ORDER_PROVIDER_RESPONSE";
    AssetBuyerError["AssetUnavailable"] = "ASSET_UNAVAILABLE";
    AssetBuyerError["SignatureRequestDenied"] = "SIGNATURE_REQUEST_DENIED";
    AssetBuyerError["TransactionValueTooLow"] = "TRANSACTION_VALUE_TOO_LOW";
})(AssetBuyerError = exports.AssetBuyerError || (exports.AssetBuyerError = {}));
//# sourceMappingURL=types.js.map